<template>
  <div id="app">
    <reactive-base
      app="oncology"
      url="https://search-springerhealthcaredev-diuqs74ej2l5d4hnevbtfhloui.eu-west-2.es.amazonaws.com">
      <div>

        <div class="mainfiller">
          <div class="b">
            <div class="searchbar flex">
              <DataSearch
                componentId="SearchText"
                iconPosition="right"
                :dataField="['chapterTitle','chapterExperts.creator','text']"
                className="data-search"
                :showClear="true"
                filterLabel="Searching for"
                autosuggest="true"
                placeholder="Search for chapter"/>
            </div>
          </div>
        </div>
      </div>
      <div class="maincontainer flex">

        <div class="filters-container" :class="{ hide: showBooks }">

          <multi-list
            componentId="Orderable"
            dataField="XXXbookFlaggedForOrderable.keyword"
            class="filter"
            title="Available to order"
            :showSearch="false"
            :react="{ and: ['SearchText', 'Filters', 'Authors','PublishedYear'] }"
          />
          <multi-list
            componentId="Subjects"
            dataField="bookSubjectGroup.BookSubject.keyword"
            class="filter"
            sortBy="asc"
            title="Categories"
            :showFilter="true"
            selectAllLabel="All categories"
            :react="{ and: ['SearchText', 'Filters', 'Authors','PublishedYear'] }"
          />
          <multi-list
            componentId="Filters"
            dataField="chapterFilterTerms.filterTerm.keyword"
            class="filter"
            title="Topics"
            sortBy="asc"
            selectAllLabel="All filters"
            :react="{ and: ['SearchText', 'Subjects', 'Authors','PublishedYear'] }"
          />
          <multi-list
            componentId="Authors"
            dataField="chapterExperts.creator.keyword"
            class="filter"
            title="Authors"
            sortBy="asc"
            selectAllLabel="All authors"
            :react="{ and: ['SearchText', 'Subjects', 'Filters','PublishedYear'] }"
          />
          <range-slider
            componentId="PublishedYear"
            dataField="bookPublishedYear"
            title="Published Year"
            :range='{
						start: 2010,
						end: 2018
					}'
            class="filter"
            :react="{ and: ['SearchText', 'Subjects', 'Authors','Filters'] }"

          />

          <div class="c">
            <span class="menuoption"><a href='#'>About</a></span>
            <span class="menuoption"><a href='#'>Cookies</a></span>
            <span class="menuoption"><a href='#'>Legal information</a></span>
            <span class="menuoption"><a href='#'>Privacy</a></span>


          </div>

        </div>

        <div class="result-list-container">

          <div class="filter-controls">
            <button class="toggle" @click="switchContainer">
              {{ showBooks ? 'Show Filters' : 'Hide Filters' }}
            </button>
            <SelectedFilters class="myfilters" showClearAll={true} clearAllLabel="Clear filters"/>
          </div>
          <reactive-list
            componentId="SearchResult"
            dataField="original_title.keyword"
            className="result-list"
            paginationAt="both"
            :pagination="true"
            :pages="5"
            :size="10"
            :class="{ full: showBooks }"
            :infiniteScroll="false"
            :react="{ and: ['Orderable','SearchText','Filters', 'PublicationYear', 'Authors', 'Subjects'] }">
            <div slot="renderItem" class="renderItem" slot-scope="{ item }">
              <div class="book-header"><h1>{{ item.bookTitle }}, chapter {{item.chapterNo}}: {{ item.chapterTitle
                }}</h1></div>
              <div class="flex book-content" key="item._id">
                <div>
                  <img :src=" signedHost + '/.netlify/functions/api/thumbnails/' + item.bookDOI + '/thumbnails/1.jpg'" alt="Book Cover" class="book-image"/>
                </div>
                <div class="column justify-top ml20 infopanel">
                  <div class="bookPanelDescription">
                    <span class="bookLabel">Book:&nbsp;</span>
                    <span class="bookInfo">{{ item.bookTitle }}</span>
                  </div>
                  <div class="bookPanelDescription">
                    <span class="bookLabel">Published:&nbsp;</span>
                    <span class="bookInfo">{{ item.bookPublishedYear }}</span>
                  </div>
                  <div class="bookPanelDescription">
                    <span class="bookLabel">Authors:&nbsp;</span>
                    <span v-for="(creator, index) in item.chapterExperts" class="bookInfo" :key="index">
										{{creator.creator}},
									</span>
                  </div>
                  <div class="bookPanelDescription">
                    <span class="bookLabel">Abstract:&nbsp;</span>
                    <span class="bookInfo">{{ item.chapterAbstract }}</span>
                  </div>
                  <div class="button-area-line">
                    <a target="_blank" @click="openBook(item.chapterDOI)" href="#" class="open">Open This Chapter</a>
                    <a target="_blank" @click="orderBook(item.bookDOI)" href="#" class="open">Open Book</a>
                    <a href="#" class="order" v-bind:class="{ hideMe: item.bookFlaggedForOrderable=='No'}"
                       @click="orderBook">Order Full Book</a>
                  </div>
                </div>

              </div>
            </div>
          </reactive-list>
        </div>
      </div>
    </reactive-base>
  </div>
</template>

<script>
  import './../styles.css'
  import './../styles2.css'

  export default {
    name: 'app',
    data: function () {
      return {
        showBooks: window.innerWidth <= 768 ? true : false,
        signedHost: process.env.NODE_ENV === 'development' ? 'http://localhost:9000' : '',
      }
    },
    methods: {
      openBook: function (bookId) {
        document.cookie = `BookID=${bookId}`
        window.open(`${this.signedHost}/.netlify/functions/api/open/${bookId}`)
      },
      switchContainer: function () {
        return (this.showBooks = !this.showBooks)
      },
      orderBook: function () {
        alert('Book order processing available after integration with user database', 'Feature not fully implemented')
      },
    },
  }
</script>
